'use strict';

var React = require('react');

var SvgDigitalMediaReceiverMajor = function SvgDigitalMediaReceiverMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 4a.75.75 0 0 1 .75-.75 5.75 5.75 0 0 1 5.75 5.75.75.75 0 0 1-1.5 0 4.25 4.25 0 0 0-4.25-4.25.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.75a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 8.25a.75.75 0 0 1 .75.75v1.499h4c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-9.5a1.75 1.75 0 0 1-1.75-1.75v-2.5c0-.966.784-1.75 1.75-1.75h4v-1.499a.75.75 0 0 1 .75-.75Zm-4.75 3.749a.25.25 0 0 0-.25.25v2.5c0 .139.112.25.25.25h9.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25h-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5.75a.75.75 0 0 0 0 1.5 1.75 1.75 0 0 1 1.75 1.75.75.75 0 0 0 1.5 0 3.25 3.25 0 0 0-3.25-3.25Z"
  }));
};
SvgDigitalMediaReceiverMajor.displayName = "DigitalMediaReceiverMajor";

exports.SvgDigitalMediaReceiverMajor = SvgDigitalMediaReceiverMajor;
